/**
 * @name AnchorGroup.BannerExtension.BannerExtension.js
 * 
 * @author Anchor Group : Jack Steiner <jsteiner@anchorgroup.tech>
 *
 * @since 2025-11-17
 * 
 * @file Create Banner to display versapay disclaimer.
 * 
 */
define(
	'AnchorGroup.BannerExtension.BannerExtension'
	, [
		'AnchorGroup.BannerExtension.BannerExtension.View'
	]
	, function (
		BannerExtensionView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				const Layout = container.getComponent('Layout');
				const userProfile = container.getComponent('UserProfile');
				var Environment = container.getComponent("Environment");
				var topText = Environment.getConfig("Banner.topText");
				var bottomText = Environment.getConfig("Banner.bottomText");
				var versapayLink = Environment.getConfig("Banner.versapayLink");
				
				// Get user profile and check if logged in
				userProfile.getUserProfile().then(function (profile) {
					if (profile && profile.isloggedin) {
						// Only add the banner view if user is logged in and config exists
						if (topText && bottomText && versapayLink){
							Layout.addChildView('BannerExtension.View', function () {
								return new BannerExtensionView({
									topText: topText,
									bottomText: bottomText,
									versapayLink: versapayLink
								});
							});
						}
					}
				});
			}
		};
	});
